import { render, staticRenderFns } from "./QuotesList.vue?vue&type=template&id=879c45f4&scoped=true&"
import script from "./QuotesList.vue?vue&type=script&lang=ts&"
export * from "./QuotesList.vue?vue&type=script&lang=ts&"
import style0 from "./QuotesList.vue?vue&type=style&index=0&id=879c45f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879c45f4",
  null
  
)

export default component.exports